/* eslint-disable prettier/prettier */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState, useEffect } from "react";

// react-router-dom components
import { Link, useLocation } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";
import Grid from "@mui/material/Grid";
import MuiLink from "@mui/material/Link";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import { useNavigate } from "react-router-dom";
// Images
import bgImage from "assets/images/fondoesf.jpeg";
import logoESF from "assets/images/LogoESF.png";
import logoGMF from "assets/images/LogoGMF3.png";
import { LogInPublico } from "store/login/loginSlice";
import { useDispatch } from "react-redux";
import toast, { Toaster } from "react-hot-toast";
import Loading from "components/loading";

function Basic() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [user, setuser] = useState(null);
  const [password, setpassword] = useState(null);
  const [message, setmessage] = useState(location.state?.message ? location.state?.message : null);
  const [loading, setloading] = useState(false);
  const login = async () => {
    //navigate("/dashboard")

    if (!user) {
      toast.error("Ingresar usuario para continuar");
      return false;
    }

    if (!password) {
      toast.error("Ingresar contraseña para continuar");
      return false;
    }
    setloading(true);
    const respuesta = await dispatch(LogInPublico(user, password));
    setloading(false);
    if (respuesta.code === "Ok") {
      navigate("/dashboard");
    } else {
      toast.error("Datos de acceso incorrectos");
      setmessage("Datos de acceso incorrectos");
    }
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        login();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [user, password]);

  return (
    <BasicLayout image={bgImage}>
      <Card
        style={{
          background: "none",
          boxShadow:
            "0rem 1rem 3rem 0rem rgba(0, 0, 0, 0.14),0rem 1rem 1rem 0.5rem rgba(0, 0, 0, 0.2),0rem 0.0625rem 0.3125rem 0rem rgba(0, 0, 0, 0.12)",
        }}
      >
        <MDBox textAlign="center">
          {message ? (
            <MDTypography
              sx={{
                opacity: 0.9,
                fontSize: "0.9rem",
                background: "red",
                borderRadius: " 1rem 1rem 0 0",
              }}
            >
              {message}
            </MDTypography>
          ) : null}
        </MDBox>
        <MDBox
          display="flex"
          flexDirection={{ xs: "column", sm: "column", md: "row" }}
          alignItems="center"
          justifyContent="center"
          marginTop="10px"
        >
          {/* Imagen izquierda */}
          <MDBox component="img" src={logoESF} alt="Logo ESF" width="40%" />

          {/* Barra vertical (horizontal en pantallas pequeñas) */}
          <MDBox
            sx={{
              width: { xs: "50%", md: "2px" }, // ancho completo en móviles, línea vertical en desktop
              height: { xs: "2px", md: "50px" }, // barra horizontal en móviles, vertical en desktop
              backgroundColor: "white !important",
              opacity: 0.7,
              my: { xs: 1, md: 0 },
              mx: { xs: 0, md: 2 },
            }}
          />

          {/* Imagen derecha */}
          <MDBox component="img" src={logoGMF} alt="Logo GMF" width="40%" />
        </MDBox>

        <MDBox textAlign="center">
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={2} mb={2}>
            Bienvenido
          </MDTypography>
          <MDTypography sx={{ opacity: 0.9, fontSize: 14 }}>
            Por favor incia sesión para continuar
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox component="form" role="form">
            <MDBox mb={2}>
              <MDInput
                type="text"
                label="Usuario"
                fullWidth
                onChange={(evt) => setuser(evt.target.value)}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Contraseña"
                fullWidth
                color="primary"
                onChange={(evt) => setpassword(evt.target.value)}
              />
            </MDBox>
            <MDBox display="flex" alignItems="center" ml={-1}></MDBox>
            <MDBox mt={4} mb={1}>
              {loading ? (
                <Loading title="" />
              ) : (
                <MDButton variant="gradient" color="primary" fullWidth onClick={() => login()}>
                  Iniciar sesión
                </MDButton>
              )}
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
      <Toaster
        toastOptions={{ style: { backgroundColor: "#5873B8", fontSize: 12, color: "white" } }}
      />
    </BasicLayout>
  );
}

export default Basic;
